<template>
  <div class="filter_wrapper">
    <div class="left_wrapper">
      <div class="icon_serach_wrapper">
        <img :src="getAllPatientsIcon" />
        <p>ALL PATIENTS</p>
      </div>
      <el-input
        placeholder="Search"
        class="search_box"
        :value="searchText"
        @input="handleTextChange"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <div v-if="getUserType === 'observer'" class="right_wrapper">
      <div class="right_filter">
        <p class="filter_text">Filter data by</p>
        <el-select
          v-model="selectedPatientTag"
          placeholder="All Sites"
          class="dropdown"
          @change="handlePatientTagChange"
        >
          <el-option
            v-for="item in getFilterPatinetsTags"
            :key="item.tag"
            :value="{ ...item, name: getTagName(item.tag) }"
          >
            <div class="select_menu_wrapper">
              <div class="tag_name_wrapper">
                <DeviceTagIcon :color="getTagColor(item.tag)" />
                <span class="tag_name">{{ getTagName(item.tag) }}</span>
              </div>
              <span>{{ item.count }}</span>
            </div>
          </el-option>
        </el-select>
      </div>
    </div>
    <div v-else>
      <el-radio v-model="dataType" label="patient">Patient Data</el-radio>
      <el-radio v-model="dataType" label="doctor">Doctor Data</el-radio>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import section1Svg from "../icons/section1.svg";
import DeviceTagIcon from "@/module/component/DeviceTagIcon";

export default {
  data() {
    return {
      dataType: 'patient',
      searchText: "",
      selectedPatientTag: null,
    };
  },
  watch: {
    dataType() {
      this.$emit('dataType', this.dataType)
    }
  },
  mounted() {
    this.$emit('dataType', this.dataType)
  },
  computed: {
    ...mapGetters(["getUserType"]),
    ...mapGetters("overview", ["getFilterPatinetsTags"]),
    ...mapGetters("provider", ["getTagToColorMapping"]),
    getAllPatientsIcon() {
      return section1Svg;
    },
    getCountOfAllTags() {
      return this.patientTags.reduce((acc, val) => acc + val.count, 0);
    },
  },
  methods: {
    ...mapActions("overview", ["changePatientTag", "changeSearchHandler"]),
    getTagColor(tag) {
      let tagObj = this.getTagToColorMapping.filter((obj) => obj.id === tag);
      if (tagObj.length) return tagObj[0].color;
      else return "#000000";
    },
    getTagName(tag) {
      let tagObj = this.getTagToColorMapping.filter((obj) => obj.id === tag);
      if (tagObj.length) return tagObj[0].name;
      else return "";
    },
    handlePatientTagChange(data) {
      this.selectedPatientTag = data.name;
      this.changePatientTag(data.tag);
    },
    getTagColor(tag) {
      let tagObj = this.getTagToColorMapping.filter((obj) => obj.id === tag);
      if (tagObj.length) return tagObj[0].color;
      else return "#000000";
    },
    getTagName(tag) {
      let tagObj = this.getTagToColorMapping.filter((obj) => obj.id === tag);
      if (tagObj.length) return tagObj[0].name;
      else return "";
    },
    handleTextChange(val) {
      this.searchText = val;
      this.changeSearchHandler(val);
    },
  },
  components: {
    DeviceTagIcon,
  },
};
</script>

<style scoped>
.filter_wrapper {
  display: flex;
  padding: 10px 36px;
  justify-content: space-between;
  align-items: center;
}

.left_wrapper {
  display: flex;
  flex: 0.4;
}

.right_wrapper {
  flex: 0.4;
}

.icon_serach_wrapper {
  display: flex;
  flex: 0.23;
  align-items: center;
  gap: 5px;
}

.icon_serach_wrapper p {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  text-transform: uppercase;
  color: #333333;
}

.search_box {
  flex: 0.7;
  width: 280px;
  background: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 2px;
  font-size: 12px;
}

.filter_text {
  font-weight: 400;
  font-size: 16px;
  line-height: 17px;
  color: #333333;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.right_filter {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: flex-end;
}

.dropdown {
  font-size: 14px;
  width: 250px;
  padding: 0.5rem;
}

.filter_inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.select_menu_wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tag_name_wrapper {
  display: flex;
  align-items: center;
}

.tag_name {
  margin-left: 10px;
}
</style>
